"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide7 = exports.HomepageSlide7 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
class HomepageSlide7 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 1rem;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: 5rem auto;
        box-sizing: border-box;
        
        view-timeline-name: --slide-timeline;
        view-timeline-axis: block;
      }

      div.title-container {
        position: relative;
      }
      
      @keyframes animate-title {
        from { transform: scale(0.75); bottom: 90%; }
        to { transform: scale(1); bottom: 0; }      
      }
      div.title {
        position: absolute;
        font-size: 8rem;
        text-align: center;
        font-family: 'quaaykop-medium', sans-serif;
        
        animation: animate-title linear;
        animation-timeline: --slide-timeline;
        animation-range: entry 40% entry 120%;
        animation-fill-mode: both;
      }
      
      img {
        width: 100%;
      }
      
      @media (max-width: 600px) {
        :host {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 1rem;
          box-sizing: border-box;
          margin: 1rem auto;
        }
        
        div.title-container {
          display: flex;
          justify-content: center;
          height: 100vh;
        }
        
        div.title {
          font-size: 4.5rem;
        }
      }
    </style>
    <div class="title-container">
      <div class="title">AiLEENE</div>
    </div>
    <img src="/files/assets/images/slide-7.jpeg" />`;
    }
}
exports.HomepageSlide7 = HomepageSlide7;
const defineHomepageSlide7 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide7);
};
exports.defineHomepageSlide7 = defineHomepageSlide7;
